import { Box3, Euler, Object3D } from "three";

export const getObject3DBoundingBox = (object: Object3D): Box3 => {
  const box = new Box3();

  object.traverse((child: Object3D) => {
    if ("isMesh" in child && child.isMesh) {
      box.expandByObject(child);
    }
  });

  return box;
};

export const degsToRads = (degs: number): number => (degs * Math.PI) / 180;

export const radsToDegs = (rads: number) => rads * (180 / Math.PI);

export const degsToEuler = (x: number, y: number, z: number): Euler =>
  new Euler(degsToRads(x), degsToRads(y), degsToRads(z));
